import React, { useCallback, useRef, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import {
  MdPerson,
  MdSubtitles,
  MdLocationOn,
  MdLocationCity,
  MdStorage,
  MdSmartphone,
  MdPhone,
  MdEmail,
  MdInfo,
  MdPermContactCalendar,
  MdList,
} from "react-icons/md";

import { Form } from "@unform/web";
import * as Yup from "yup";
import getValidationErrors from "../../../utils/getValidationErrors";

import { useSelector } from "react-redux";

import cnpjCpfFormatter from "../../../utils/cnpjCpfFormatter";
import { validateCNPJ } from "../../../utils/cnpjManager";

import { FormattedMessage, useIntl } from "react-intl";

import {
  Container,
  TitleContainer,
  Title,
  SessionDivider,
  Session,
  SessionContainer,
  SessionIconContainer,
  SessionTitle,
  FieldsContainer,
  ButtonsContainer,
  SwitchContainer,
} from "./styles";

import Input from "../../../components/Input";
import CpfCnpj from "../../../components/CpfCnpj";
import { Switch } from "antd";
import { useToast } from "../../../hooks/toast";
import { validateSingleFieldOnBlur } from "../../../utils/formValidations";
import api from "../../../service";
import taxes from "../../../constants/taxes";
import types from "../../../constants/types";
import AnimatedMainContainer from "../../../components/AnimatedMainContainer";
import Button from "../../../components/Button";
import SelectWithLabel from "../../../components/SelectWithLabel";
import axios from "axios";
import { cpf } from "cpf-cnpj-validator";
import { useLoading } from "../../../hooks/loading";
import TelephoneInputWithLabel, {
  getFullTelephoneNumber,
  getCountryFromTelephoneNumber,
} from "../../../components/TelephoneInputWithLabel";
import useProvisionTypes from "../../../hooks/useProvisionTypes";
import { OTHERS_SERVICE_TYPE_ID } from "../../../constants/serviceProviderTypes";
import FormButton from "../../../components/FormButton";

const UpdateUser = () => {
  const formRef = useRef(null);
  const intl = useIntl();
  const { addToast } = useToast();
  const [serviceProvider, setServiceProvider] = useState();
  const [key, setKey] = useState();
  const { user, token } = useSelector((state) => state.auth);
  const { id } = useParams();
  const { handleLoading } = useLoading();
  const [loading, setLoading] = useState(false);

  const [countries, setCountries] = useState([]);
  const [personType, setPersonType] = useState();
  const [taxesByPerson, setTaxesByPerson] = useState([]);
  const [disableTaxes, setDisableTaxes] = useState(true);
  const [documentLabel, setDocumentLabel] = useState(
    `${intl.formatMessage({ id: "id_number_cnpj_passport" })}`,
  );

  const [selectedTax, setSelectedTax] = useState();
  const [selectedOthersServiceType, setSelectedOthersServiceType] =
    useState(false);

  const history = useHistory();
  const isAdministrator = user?.role?.type === "ADMINISTRATOR";
  const [isShowInCatalog, setIsShowInCatalog] = useState(false);

  const { provisionTypes } = useProvisionTypes();

  const provision_types = [...provisionTypes].sort((a, b) => {
    if (a?.value === 0) return -1;
    if (b?.value === 0) return 1;
    return a.label.localeCompare(b.label);
  });

  const schema = Yup.object().shape({
    type: Yup.string().required("O tipo é obrigatório"),
    email: Yup.string()
      .required(
        intl.formatMessage({
          defaultMessage: "O e-mail é obrigatório",
          id: "error.email_required",
        }),
      )
      .email(
        intl.formatMessage({
          defaultMessage: "Digite um e-mail válido",
          id: "error.valid_email",
        }),
      ),
    nameLastName: Yup.string(),
    name: Yup.string().required(
      intl.formatMessage({
        id: "error.name_required",
      }),
    ),
    company_name: Yup.string().required(
      intl.formatMessage({
        id: "error.company_name_required",
      }),
    ),
    state_inscription: Yup.string(),
    city_inscription: Yup.string(),
    address_street: Yup.string(),
    address_number: Yup.string(),
    district: Yup.string(),
    state: Yup.string(),
    city: Yup.string(),
    phone: Yup.string()
      .max(30, intl.formatMessage({ id: "error.max_length" }, { length: 30 }))
      .required(intl.formatMessage({ id: "error.field_required" })),
    mobile: Yup.string()
      .max(30, intl.formatMessage({ id: "error.max_length" }, { length: 30 }))
      .required(intl.formatMessage({ id: "error.field_required" })),
    avenue: Yup.string(),
    zip_code: Yup.string(),
    provision_types: Yup.array().min(
      1,
      intl.formatMessage({ id: "select_at_least_one_of_the_options" }),
    ),
    taxes: Yup.string().required(
      intl.formatMessage({ id: "error.field_required" }),
    ),
    document: Yup.string()
      .required(
        intl.formatMessage({
          id: "error.document_required",
        }),
      )
      .test(
        "is-incorrect",
        intl.formatMessage({
          id: "error.document_invalid",
        }),
        function (value) {
          let result;
          const type = this.resolve(Yup.ref("type"));
          if (type === "I") {
            return true;
          }
          if (type === "F") {
            result = cpf.isValid(value);
          } else if (type === "J") {
            result = validateCNPJ(value);
          }
          return result;
        },
      ),
    country: Yup.string().required(
      intl.formatMessage({
        id: "error.country_required",
      }),
    ),
    othersDescription: Yup.string().test(
      "is_others_description_required",
      intl.formatMessage({
        id: "error.field_required",
      }),
      () => {
        const othersDescriptionValue =
          formRef.current.getFieldValue("othersDescription");

        return !selectedOthersServiceType || !!othersDescriptionValue;
      },
    ),
  });

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});
        setLoading(true);
        if (loading) {
          return;
        }
        await schema.validate(data, { abortEarly: false });
        api
          .patch(
            `/serviceprovider/${id}`,
            {
              accountType: data.type,
              nameLastName: data.nameLastName,
              name: data.name,
              companyName: data.company_name,
              document: data.document.replace(/[^a-z\d\s]+/gi, ""),
              stateInscription:
                data.state_inscription &&
                data.state_inscription.replace(/[^a-z\d\s]+/gi, ""),
              municipalInscription:
                data.city_inscription &&
                data.city_inscription.replace(/[^a-z\d\s]+/gi, ""),
              email: data.email,
              avenue: data.avenue,
              number: data.address_number,
              zipCode: data.zip_code,
              district: data.district,
              city: data.city,
              state: data.state,
              telephone: getFullTelephoneNumber(
                data.phone,
                data.phone_selected_country,
              ),
              mobile: getFullTelephoneNumber(
                data.mobile,
                data.mobile_selected_country,
              ),
              taxes: data.taxes,
              provisionTypes: data.provision_types,
              othersDescription: data.othersDescription,
              showInCatalog: isShowInCatalog,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then((result) => {
            addToast({
              type: "success",
              title: intl.formatMessage({
                id: "success",
              }),
              description: intl.formatMessage({
                id: "success.user_update",
              }),
            });
            history.goBack();
          })
          .catch((err) => {
            if (err.response.data.code === -7003) {
              addToast({
                type: "info",
                title: intl.formatMessage({
                  id: "info",
                }),
                description: intl.formatMessage({
                  id: "api.error." + err.response.data.code,
                }),
              });
            } else {
              addToast({
                type: "error",
                title: intl.formatMessage({
                  id: "error",
                }),
                description: intl.formatMessage({
                  id: "api.error." + err.response.data.code,
                }),
              });
            }
          })
          .finally(() => setLoading(false));
      } catch (err) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
      }
    },
    [addToast, history, id, intl, loading, schema, token],
  );

  const validationBlur = (name) => {
    let errors = formRef.current.getErrors();

    validateSingleFieldOnBlur(errors, schema, name, formRef);
  };

  const pushBack = () => {
    history.goBack();
  };

  const handleTypeChanges = (value) => {
    setPersonType(value);
    let taxeField;
    let taxeValues;
    switch (value) {
      case "F":
        taxeValues = [taxes[4]];
        taxeField = taxes.filter((tax) => tax.value === 4)[0];
        setTaxesByPerson(taxeValues);
        setDisableTaxes(true);
        setDocumentLabel(`${intl.formatMessage({ id: "document" })}`);
        formRef.current.setFieldValue("taxes", taxeField);
        break;
      case "J":
        taxeValues = [taxes[0], taxes[1], taxes[2], taxes[3]];
        taxeField = taxes.filter((tax) => tax.value === 0)[0];
        setTaxesByPerson(taxeValues);
        setDisableTaxes(false);
        setDocumentLabel(`${intl.formatMessage({ id: "id_number_cnpj" })}`);
        formRef.current.setFieldValue("taxes", taxeField);
        break;
      case "I":
        taxeValues = [taxes[5]];
        taxeField = taxes.filter((tax) => tax.value === 5)[0];
        setTaxesByPerson(taxeField);
        setDisableTaxes(true);
        setDocumentLabel(
          `${intl.formatMessage({
            id: "passport",
          })}`,
        );
        formRef.current.setFieldValue("taxes", taxeField);
        break;
      default:
        break;
    }
    formRef.current.setFieldValue("document", "");
  };

  const handleServiceTypeChanges = (typeList) => {
    setSelectedOthersServiceType(typeList?.some((type) => type.value === OTHERS_SERVICE_TYPE_ID));
  };

  useEffect(() => {
    handleLoading(true);
    api
      .get(`/serviceprovider/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((serviceProviderResponse) => {
        const output = serviceProviderResponse.data.output;
        setServiceProvider({
          ...output,
          accountType: output.accountType?.charAt(0),
        });
        setIsShowInCatalog(output.showInCatalog);
        setKey(new Date());
      })
      .catch((err) =>
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "api.error." + err.response.data.code,
          }),
        }),
      )
      .finally(() => handleLoading(false));
  }, [addToast, id, handleLoading, intl, token]);

  useEffect(() => {
    axios
      .get(
        "https://raw.githubusercontent.com/apilayer/restcountries/master/src/main/resources/countriesV2.json",
      )
      .then((result) => {
        const countries = result.data.map((country) => ({
          value: country.name,
          label: country.name,
        }));
        setCountries(countries);
      })
      .catch(() =>
        addToast({
          type: "error",
          title: intl.formatMessage({
            id: "error",
          }),
          description: intl.formatMessage({
            id: "error.could_not_load_countries",
          }),
        }),
      );
  }, [addToast, intl]);

  useEffect(() => {
    if (serviceProvider) {
      if (serviceProvider.typesList?.length > 0) {
        setSelectedOthersServiceType(
          serviceProvider.typesList.some((type) => type === OTHERS_SERVICE_TYPE_ID)
        );
      }

      const selectedTax = taxes.find(
        (tax) => tax.value === serviceProvider.taxes,
      );
      setSelectedTax(selectedTax);
      let taxeValues;
      switch (serviceProvider.accountType) {
        case "F":
          taxeValues = [taxes[4]];
          setTaxesByPerson(taxeValues);
          setDisableTaxes(true);
          setDocumentLabel(`${intl.formatMessage({ id: "document" })}`);
          setKey("TAX");
          break;
        case "J":
          taxeValues = [taxes[0], taxes[1], taxes[2], taxes[3]];
          setTaxesByPerson(taxeValues);
          setDisableTaxes(false);
          setDocumentLabel(`${intl.formatMessage({ id: "id_number_cnpj" })}`);
          setKey("TAX");
          break;
        case "I":
          taxeValues = [taxes[5]];
          setTaxesByPerson(taxeValues);
          setDisableTaxes(true);
          setDocumentLabel(
            `${intl.formatMessage({
              id: "passport",
            })}`,
          );
          setKey("TAX");
          break;
        default:
          break;
      }
    }
  }, [intl, serviceProvider]);

  // Reaplica os rotulos localizados sobre a SELECAO ATUAL do form quando o catalogo (assincrono)
  // chega ou o idioma muda. O Form (react-select) fixa o objeto {value,label} no seed do initialData;
  // reconstruir a partir de serviceProvider.typesList apagaria edicoes nao salvas. Le a selecao atual
  // e so cai para typesList quando o campo ainda nao foi inicializado (null/undefined); `[]` = selecao
  // vazia deliberada e e preservado.
  useEffect(() => {
    if (!provisionTypes.length) {
      return;
    }
    const currentSelection = formRef.current?.getFieldValue("provision_types");
    const selectedValues = Array.isArray(currentSelection)
      ? currentSelection.map((item) => item?.value ?? item)
      : serviceProvider?.typesList;
    if (!selectedValues) {
      return;
    }
    formRef.current?.setFieldValue(
      "provision_types",
      selectedValues.map((value) => ({
        value,
        label: provisionTypes.find((pt) => pt.value === value)?.label,
      }))
    );
  }, [serviceProvider, provisionTypes]);

  return (
    <AnimatedMainContainer>
      <Container>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          key={key}
          initialData={{
            nameLastName: serviceProvider?.nameLastName,
            name: serviceProvider?.name,
            company_name: serviceProvider?.companyName,
            type: serviceProvider?.accountType && {
              value: serviceProvider?.accountType,
              label:
                serviceProvider?.accountType === "F"
                  ? "Física"
                  : types.filter(
                      (t) => t.value === serviceProvider?.accountType,
                    )[0]?.label,
            },
            document: cnpjCpfFormatter(
              serviceProvider?.document,
              serviceProvider?.accountType,
            ),
            state_inscription: serviceProvider?.stateInscription,
            city_inscription: serviceProvider?.municipalInscription,
            country: {
              label: serviceProvider?.accountAddress?.country,
              value: serviceProvider?.accountAddress?.country,
            },
            avenue: serviceProvider?.accountAddress?.avenue,
            address_number: serviceProvider?.accountAddress?.number,
            zip_code: serviceProvider?.accountAddress?.zipCode,
            district: serviceProvider?.accountAddress?.district,
            city: serviceProvider?.accountAddress?.city,
            state: serviceProvider?.accountAddress?.state,
            phone: serviceProvider?.telephone,
            phone_selected_country: getCountryFromTelephoneNumber(
              serviceProvider?.telephone,
            ),
            mobile: serviceProvider?.mobile,
            mobile_selected_country: getCountryFromTelephoneNumber(
              serviceProvider?.mobile,
            ),
            email: serviceProvider?.email,
            taxes: selectedTax,
            provision_types: serviceProvider?.typesList?.map((value) => {
              return {
                value: value,
                label: provision_types.filter((pt) => pt.value === value)[0]
                  ?.label,
              };
            }),
            othersDescription: serviceProvider?.othersDescription,
          }}
        >
          <TitleContainer>
            <Title>
              <FormattedMessage id="user_editing" />
            </Title>
          </TitleContainer>
          <SessionDivider nr_items="2">
            <Session>
              <SessionContainer>
                <SessionIconContainer>
                  <MdInfo size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="informations" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <SelectWithLabel
                  name="type"
                  icon={MdStorage}
                  label={intl.formatMessage({
                    id: "type",
                  })}
                  placeholder={intl.formatMessage({
                    id: "type",
                  })}
                  hasLabel
                  options={types}
                  onChange={(e) => handleTypeChanges(e.value)}
                  validationBlur={validationBlur}
                  required
                />
                <Input
                  name="nameLastName"
                  icon={MdPerson}
                  placeholder={intl.formatMessage({
                    id: "name_last_name",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                />
                <Input
                  name="name"
                  icon={MdPerson}
                  placeholder={intl.formatMessage({
                    id: "trade_name",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  required
                />
                <Input
                  name="company_name"
                  icon={MdPerson}
                  placeholder={intl.formatMessage({
                    id: "corporate_name",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  required
                />
                <CpfCnpj
                  name="document"
                  icon={MdSubtitles}
                  placeholder={documentLabel}
                  hasLabel
                  validationBlur={validationBlur}
                  personType={personType}
                  required
                />
                <Input
                  name="state_inscription"
                  icon={MdSubtitles}
                  placeholder={intl.formatMessage({
                    id: "state_inscription",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                />
                <Input
                  name="city_inscription"
                  icon={MdSubtitles}
                  placeholder={intl.formatMessage({
                    id: "city_inscription",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                />
                <SelectWithLabel
                  name="country"
                  icon={MdLocationOn}
                  label={intl.formatMessage({
                    id: "country",
                  })}
                  placeholder={intl.formatMessage({
                    id: "country",
                  })}
                  options={countries}
                  validationBlur={validationBlur}
                  disabled
                  required
                />
                <Input
                  name="email"
                  icon={MdEmail}
                  placeholder="E-mail"
                  validationBlur={validationBlur}
                  hasLabel
                  disabled={!isAdministrator}
                  required
                />
                <SelectWithLabel
                  name="taxes"
                  icon={MdStorage}
                  label={intl.formatMessage({
                    id: "taxes",
                  })}
                  placeholder={intl.formatMessage({
                    id: "taxes",
                  })}
                  options={taxesByPerson}
                  validationBlur={validationBlur}
                  disabled={disableTaxes}
                  required
                />
              </FieldsContainer>
            </Session>
            <Session>
              <SessionContainer>
                <SessionIconContainer>
                  <MdPermContactCalendar size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="contact_data" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <Input
                  name="avenue"
                  icon={MdLocationOn}
                  placeholder={intl.formatMessage({
                    id: "avenue",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  maxLength="255"
                />
                <Input
                  name="address_number"
                  icon={MdLocationOn}
                  placeholder={intl.formatMessage({
                    id: "address_number",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  maxLength="80"
                />
                <Input
                  name="zip_code"
                  icon={MdLocationOn}
                  placeholder={intl.formatMessage({
                    id: "zip_code",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  maxLength="80"
                />
                <Input
                  name="district"
                  icon={MdLocationOn}
                  placeholder={intl.formatMessage({
                    id: "district",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  maxLength="255"
                />
                <Input
                  name="city"
                  icon={MdLocationCity}
                  placeholder={intl.formatMessage({
                    id: "city",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  maxLength="255"
                />
                <Input
                  name="state"
                  icon={MdLocationCity}
                  placeholder={intl.formatMessage({
                    id: "state",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  maxLength="255"
                />
                <TelephoneInputWithLabel
                  name="phone"
                  placeholder={intl.formatMessage({
                    id: "phone",
                  })}
                  label={intl.formatMessage({
                    id: "phone",
                  })}
                  labelOrientation="vertical"
                  icon={MdPhone}
                  validationBlur={validationBlur}
                  required
                />
                <TelephoneInputWithLabel
                  name="mobile"
                  placeholder={intl.formatMessage({
                    id: "mobile",
                  })}
                  label={intl.formatMessage({
                    id: "mobile",
                  })}
                  labelOrientation="vertical"
                  icon={MdSmartphone}
                  validationBlur={validationBlur}
                  required
                />
                <FormButton
                  size="auto"
                  fontSize="12px"
                  type="button"
                  onClick={() => null}
                  style={{ cursor: "default" }}
                >
                  <FormattedMessage id="SUPPLIER_CATALOG" />
                </FormButton>
                <SwitchContainer>
                  <Switch
                    checked={isShowInCatalog}
                    onChange={setIsShowInCatalog}
                  />
                  <span>{intl.formatMessage({ id: "ADD_SUPPLIER" })}</span>
                </SwitchContainer>
              </FieldsContainer>
            </Session>
          </SessionDivider>

          <SessionDivider nr_items="2">
            <Session>
              <SessionContainer>
                <SessionIconContainer>
                  <MdList size="16px" color="#002244" />
                </SessionIconContainer>
                <SessionTitle>
                  <FormattedMessage id="service_provision" />
                </SessionTitle>
              </SessionContainer>
              <FieldsContainer>
                <SelectWithLabel
                  label={intl.formatMessage({
                    id: "types",
                  })}
                  placeholder={intl.formatMessage({
                    id: "select_at_least_one_of_the_options",
                  })}
                  isMulti
                  options={provision_types}
                  name="provision_types"
                  icon={MdList}
                  validationBlur={validationBlur}
                  required
                  onChange={(type) => handleServiceTypeChanges(type)}
                />
                <Input
                  name="othersDescription"
                  placeholder={intl.formatMessage({
                    id: "others",
                  })}
                  hasLabel
                  validationBlur={validationBlur}
                  maxLength="255"
                  required={selectedOthersServiceType}
                  disabled={!selectedOthersServiceType}
                />
              </FieldsContainer>
            </Session>
            <Session></Session>
          </SessionDivider>

          <ButtonsContainer>
            <Button size="100px" type="submit" loading={loading}>
              <FormattedMessage id="update_data" />
            </Button>

            <Button color="#C9C9C9" type="button" onClick={pushBack}>
              <FormattedMessage id="goback" />
            </Button>
          </ButtonsContainer>
        </Form>
      </Container>
    </AnimatedMainContainer>
  );
};

export default UpdateUser;
